import { useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import { contextualInformationLoading } from 'redux/slices/contextualSlice';
import { R } from '../../../resources/R';
import '../../../resources/styles/components/commons/loading.scss';
import { useTranslate } from 'context/languageContext';

export default function Loading() {

  const contextualLoading = useSelector(contextualInformationLoading);
  const t = useTranslate();

  return (
    contextualLoading ? <div className='content-loading'>
      <div className='loading'>
        <ClipLoader
          color={R.colors.neutral.gray_700}
          speedMultiplier={0.5}
          size={30}
        />
        <div className='loading-text'>{t('lb_cargando')}</div>
      </div>
      <div className='background'/>
    </div> : null
  );
}
